import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  users: null,
  currentUser: null,
};

const authSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    },
    forgetCurrentUser: (state, action) => {
      state.currentUser = null;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
